module.exports = __webpack_public_path__ + "distribute-icon.c6f8fb96a2891d7d7cbafce0aa90bc8a.svg";